// src/features/auth/components/PendingApprovalModal.jsx
import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  useTheme,
} from '@mui/material';
import PendingApprovalPresentation from '@/features/auth/components/PendingApprovalPresentation';

const PendingApprovalModal = ({ open, onClose, audience = 'generic' }) => {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: theme.shape.borderRadius * 2,
          boxShadow: theme.shadows[10],
        },
      }}
    >
      <DialogContent sx={{ pt: 4, pb: 3 }}>
        <PendingApprovalPresentation audience={audience} mode="loginPending" />
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: 'center',
          pb: 3,
          px: 3,
        }}
      >
        <Button
          onClick={onClose}
          variant="contained"
          color="primary"
          sx={{
            minWidth: 120,
            textTransform: 'none',
            fontWeight: 500,
          }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

PendingApprovalModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  audience: PropTypes.oneOf(['manager', 'investor', 'generic']),
};

export default PendingApprovalModal;
